import styled from '@emotion/styled';
import { darkTheme } from '../../../../theme';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #ffffff 0%, #d7dfff 100%);

  transition:
    transform 0.6s ease-in-out,
    opacity 0.6s ease-in-out;
`;

export const ContentSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`;

export const Heading = styled.h1<{ isLight: boolean }>`
  margin: 0;
  font-family: Custora;
  font-weight: 400;
  font-style: Regular;
  font-size: 32px;
  leading-trim: NONE;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #e9ecf5;
`;

export const SubHeading = styled.h1<{ isLight: boolean }>`
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
  padding: 0;
  margin: 0;
`;

export const LogoWrapper = styled.div`
  padding-top: 94px;
`;

export const ClickableLogo = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  padding-top: 0;
  width: auto;
  height: 20px;
  margin: 0;
  cursor: pointer;
`;

export const PasswordFieldContainer = styled.div`
  width: 100%;
`;

export const ContinueButton = styled.button`
  width: 100%;
  height: 50px;
  padding: 12px 0;
  border: none;
  border-radius: 9px;
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  /* colour & cursor switch automatically */
  background: #5e84ed; /* enabled  */
  cursor: pointer;
  transition: background 0.2s ease;

  &:disabled {
    color: #b7bdcb99;
    background: #2b2d33; /* disabled */
    cursor: not-allowed;
  }
`;

export const SkipButton = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
  height: 50px;
  width: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SkipButtonWithBorder = styled.button`
  background: none;
  border: none;
  color: #5e84ed;
  cursor: pointer;
  font-family: ${darkTheme.fonts.secondary};
  font-size: 16px;
  font-weight: 600;
  padding: 0;
  height: 50px;
  width: 100%;
  border: 1px solid #5e84ed;
  border-radius: 8px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 32px;
`;

export const EyeButton = styled.button`
  position: absolute;
  right: 12px;
  bottom: 12px;
  background: none;
  border: none;
  padding: 0;
  height: 24px;
  width: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6f7a8c;

  /* prevent deformation */
  svg {
    display: block; /* removes inline-svg baseline shift */
  }
  z-index: 1;
`;
/* group every TextField + eye icon */
export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
